import { isAccessible } from "../utils/accessible-tab.js";
var Direction = /* @__PURE__ */ ((Direction2) => {
  Direction2[Direction2["Forward"] = 0] = "Forward";
  Direction2[Direction2["Backward"] = 1] = "Backward";
  return Direction2;
})(Direction || {});
function keyboardControl(tabs, e, isRTL) {
  const key = e.key.toLowerCase();
  let direction = 0 /* Forward */;
  let startIndex = tabs.findIndex(
    (tab) => tab.getAttribute("aria-selected") === "true"
  );
  switch (key) {
    case "arrowleft":
      direction = isRTL ? 0 /* Forward */ : 1 /* Backward */;
      break;
    case "arrowright":
      direction = isRTL ? 1 /* Backward */ : 0 /* Forward */;
      break;
    case "home":
      startIndex = -1;
      break;
    case "end":
      startIndex = tabs.length;
      direction = 1 /* Backward */;
      break;
    default:
      return;
  }
  e.preventDefault();
  return findNextClosestAccessibleTab(tabs, startIndex, direction);
}
function findNextClosestAccessibleTab(tabs, startIndex, direction = 0 /* Forward */) {
  let tab;
  const length = tabs.length;
  const step = direction === 0 /* Forward */ ? 1 : -1;
  for (let offsetIndex = 0 + step; Math.abs(offsetIndex) < length; offsetIndex += step) {
    tab = tabs[(startIndex + offsetIndex + length) % length];
    if (isAccessible(tab))
      return tab;
  }
}
export {
  keyboardControl
};
